import styled from 'styled-components';
import React from 'react';

const StyledLabel = styled.label`
    width: 35%;
    display: inline-block;
    font-size: 2em;
    vertical-align: center;
    margin-top: 1em;
    text-align: center;
`;

const ErrorLabel = ({ text = '' }) => <StyledLabel>{text}</StyledLabel>;

export default ErrorLabel;
